import { render, staticRenderFns } from "./AddNewUserForm.vue?vue&type=template&id=511e986c&scoped=true&"
import script from "./AddNewUserForm.vue?vue&type=script&lang=js&"
export * from "./AddNewUserForm.vue?vue&type=script&lang=js&"
import style0 from "./AddNewUserForm.vue?vue&type=style&index=0&id=511e986c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511e986c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInput: require('/workspace/components/Form/FormInput.vue').default})
